import React from "react";
import { useTranslation } from "react-i18next";
import LeaderBoardTable from "./leaderboard-table";
import styles from "./leaderboard.module.css";
import useIsMobile from "hooks/detect-mobile-screen";

const LeaderBoard = ({ leaderboard, team_id }) => {
  const { t } = useTranslation();
  const isMobile = useIsMobile(768);

  const currentTeam = leaderboard.find((team) => team.team_id === team_id);

  return (
    <div className={styles["leaderboard-card"]}>
      <div className={styles["leaderboard-header"]}>
        <div className={styles["header-ranking"]}>
          <h1 className="title-3">{t("dashboard.leaderboard.title")}</h1>
          <p className={styles["team-count"]}>
            {t("dashboard.leaderboard.description", {
              count: leaderboard.length,
            })}
          </p>
        </div>
        {!isMobile && (
          <p className="title-4" data-testid="ranking-text">
            {t("dashboard.leaderboard.ranking", {
              ranking: currentTeam.position,
            })}
          </p>
        )}
      </div>
      <LeaderBoardTable teams={leaderboard} currentTeam={currentTeam} />
    </div>
  );
};

export default LeaderBoard;
